<template>
  <div class="meter-reading-large-users">
    <Echart ref="option" :options="option" style="height: 100%" />
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'MeterReadingLargeUsers',
  data() {
    return {
      option: {},
      url: {
        largeUsers: "/jeecg-engineering/ticket/tickets/list"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.getData()
    },
    
    getData() {
      getAction(this.url.largeUsers).then(res => {
        if (res.success) {
          this.setOption(res.result)
        } else {
          this.setOption(this.getMockData())
        }
      }).catch(() => {
        this.setOption(this.getMockData())
      })
    },
    
    getMockData() {
      return {
        weekDays: [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')],
        waterUsage: [134, 133, 122, 144, 314, 223, 414],
        readRate: [12, 23, 34, 12, 23, 33, 78]
      }
    },
    
    setOption(data) {
      const seriesData = []
      
      seriesData[0] = {
        name: this.$t('水量'),
        type: 'bar',
        barMaxWidth: 14,
        stack: 'sum',
        smooth: true,
        symbol: "none",
        animationDelay: (0 * 200) - 100,
        animationDuration: 300,
        data: data.waterUsage || [134, 133, 122, 144, 314, 223, 414]
      }
      
      seriesData[1] = {
        name: this.$t('抄表率'),
        type: 'line',
        yAxisIndex: 1,
        symbol: 'circle',
        animationDelay: 1000,
        stack: 'Total',
        smooth: true,
        animationDuration: 300,
        data: data.readRate || [12, 23, 34, 12, 23, 33, 78]
      }

      this.option = {
        color: ['#0394FF', '#50E3C2', '#F6BB2F'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#CEE2FF'
          },
          itemHeight: 10,
          right: 0,
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: data.weekDays || [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')],
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671'],
            }
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('水量(万吨)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('抄表率(%)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value} %',
              color: '#D1F3FF',
              fontSize: 10
            }
          }
        ],
        series: seriesData
      }
    }
  }
}
</script>

<style lang="less" scoped>
.meter-reading-large-users {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-container {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}

@media (max-width: 1200px) {
  .meter-reading-large-users {
    padding: 0;
  }
}
</style>